export default "__VITE_ASSET__Cp5JVe07__"